// extracted by mini-css-extract-plugin
export default {"contanier":"contanier___XRQDq","bg":"bg___JeX8b","buttons":"buttons___SWwTG"};